module.exports = __webpack_public_path__ + "static/img/books-stack-of-three-white.e66824e3.svg";